import React from 'react';
import { GridStyled } from './styled.js';

const Grid = ({ children }) => {
  return <GridStyled>{children}</GridStyled>;
};

export default Grid;



// WEBPACK FOOTER //
// ./src/pages/machine-to-machine/components/Grid/Grid.js